import axios from 'utils/axios';
import { convertToFormData } from 'utils/helpers';

export const getAllDeploymentRequests = async ({
    perPage = 10,
    pageNo = 1,
    query = '',
    showDisabled = false,
    tags = [],
    startDate = '',
    endDate = ''
}) => {
    const formattedTags = tags.toString();
    const response = await axios.get('deployment-requests/', {
        params: { perPage, pageNo, showDisabled, query, tags: formattedTags, startDate, endDate }
    });
    return response.data;
};

export const createUpdateDeploymentRequest = async (data) => {
    const formData = convertToFormData(data);
    const response = await axios.post('deployment-requests', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response.data;
};

export const getDeploymentRequestsSummary = async () => {
    const response = await axios.get('deployment-requests/summary');
    return response.data;
};

export const approveDeploymentRequest = async (id) => {
    const response = await axios.post('deployment-requests/approve', { id });
    return response.data;
};

export const denyDeploymentRequest = async (data) => {
    const response = await axios.post('deployment-requests/deny', data);
    return response.data;
};
